import domReady from '@wordpress/dom-ready';

domReady(() => {
  let sticky = 40;
  let timer = null;

  function stickyNavbar() {
    const st = window.scrollY;
    if (st >= sticky) {
      document.body.classList.add('sticky-navbar');
    } else if (st === 0) {
      document.body.classList.remove('sticky-navbar');
    }

    sticky = st + 40;
  }

  window.addEventListener('scroll', () => {
    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
      // actual callback
      stickyNavbar();
    }, 50);
  });

  stickyNavbar();
});
